// extracted by mini-css-extract-plugin
export default {"f":"c967e0b7e1","main":"_1788330fa6","btn":"_7c61bd97d5","w":"b2870887e4","h":"_0a70ffb9d4","lh25":"_06776550a9","wb":"_69a3bf18e2","b":"c01c44920d","bx":"_060d808fd3"};